import { createStorefrontApiClient } from "@shopify/storefront-api-client";

let _warned = false;

export function getStorefrontClient() {
  const config = window.DUSK;

  if (!config || !config.storefrontAccessToken || !config.storefrontApiVersion) {
    if (!_warned) {
      console.warn(
        "[Aurora] window.DUSK.storefrontAccessToken/storefrontApiVersion is missing; product badges are disabled.",
      );
      _warned = true;
    }
    return null;
  }

  return createStorefrontApiClient({
    storeDomain: window.Shopify?.shop ?? "",
    publicAccessToken: config.storefrontAccessToken,
    apiVersion: config.storefrontApiVersion,
  });
}
